import React, { Component } from "react";
import { DKLabel, showAlert, DKIcon } from "deskera-ui-library";

class AddNewList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const list = [];

    return (
      <div
        className="column bg-white border-radius-s border-m shadow-m position-absolute pb-s"
        style={{ top: 40, right: -5, width: 150, zIndex: 9999 }}
      >
        <DKLabel text="Create New" className="fw-m fs-m pt-r pb-s p-h-s" />
        {list.map((obj, index) => {
          return (
            <div
              className="row listPickerBG cursor-hand parent-width border-box"
              style={{ padding: 12 }}
              onClick={() => {
                this.navigateToCreate(index);
                this.props.onClose();
              }}
            >
              <DKIcon src={obj.icon} className="ic-s" />
              <DKLabel text={obj.title} className="ml-r" />
            </div>
          );
        })}
      </div>
    );
  }

  navigateToCreate(index) {
    switch (index) {
      default:
        showAlert("Cell tapped ", "Index- " + index);
        break;
    }
    this.props.onClose();
  }
}

export default AddNewList;
